import axios from 'axios'
import { normalizeAttendanceSettings } from '@/utils/attendanceSettings'

const origin = process.env.VUE_APP_API_ORIGIN

const responseData = response => response.data

export default {
  get () {
    return axios
      .get(origin + '/setting/info')
      .then(responseData)
      .then(normalizeAttendanceSettings)
  },
  update (payload) {
    return axios.post(origin + '/setting/update', payload).then(responseData)
  },
  /*
   * 有休の付与ルールも**別の口。**
   *
   * 自社設定の保存（/setting/update）は全項目をまとめて送る作りなので、
   * 会社名を直しただけで付与ルールも一緒に飛ぶ形にはしない。
   * 付与日数は**労働基準法39条の下限**が効く値で、ついでに書き換わって
   * よいものではない。
   *
   * 保存は35区分そろった一式で送る。1区分ずつ送れる形にすると
   * **区分に穴を作れる**——付与は「勤続以下でいちばん大きい区分」を
   * 採るので、6.5年の行が消えると勤続20年の人が5.5年の行へ落ちる。
   */
  getPaidGrantRules () {
    return axios.get(origin + '/setting/paid-grant-rules').then(responseData)
  },
  replacePaidGrantRules (payload) {
    return axios
      .post(origin + '/setting/paid-grant-rules/replace', payload)
      .then(responseData)
  },

  /*
   * 36協定は、**自社設定とは別の口で保存する。**
   *
   * 同じ口だったころ、編集画面はフォームの全項目をまとめて送っていた。
   * 会社名を1文字直して保存しただけで協定の全項目が一緒に飛び、適用開始日が
   * 空だと「いま効いている協定を書き換える」ほうへ入る。特別条項の有無
   * ひとつで年の天井が360時間から720時間へ変わるのに、**書き換わったことは
   * 画面のどこにも出ない。**だから送り先そのものを分ける。
   *
   * 「作る」と「編集する」も別にしてある。打った日が既存と一致したら
   * 書き換える作りだと、打ち間違いで去年の協定が書き換わり、入れた人には
   * 追加したように見える。
   */
  createOvertimeAgreement (payload) {
    return axios
      .post(origin + '/setting/overtime-agreement/create', payload)
      .then(responseData)
  },
  updateOvertimeAgreement (payload) {
    return axios
      .post(origin + '/setting/overtime-agreement/update', payload)
      .then(responseData)
  },
  /*
   * 請求書記載情報（住所・建物名・インボイス登録番号・請求担当者・振込先・
   * 角印）も**別の口。**
   *
   * 自社設定の保存（/setting/update）は全項目をまとめて送る作りなので、そこへ
   * 混ぜると、項目を知らない画面からの保存で住所や振込先が空に戻る。
   * サーバもこの口の列を /setting/update では書かない。
   *
   * 保存は文字の5項目を全部そろえて送る（1つでも欠けるとサーバが断る）。
   * 角印（seal_image）だけは、送らなければ今のまま・空文字で消す・base64 で差し替え。
   */
  getInvoiceIssuer () {
    return axios.get(origin + '/setting/invoice-issuer').then(responseData)
  },
  saveInvoiceIssuer (payload) {
    return axios
      .post(origin + '/setting/invoice-issuer/save', payload)
      .then(responseData)
  },
  pendingApprovalStatus () {
    return axios.get(origin + '/setting/pending-approval-notification/status').then(responseData)
  },
  testPendingApprovalNotification () {
    return axios.post(origin + '/setting/pending-approval-notification/test').then(responseData)
  }
}
